import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from './Guards/authenticated.guard';
import { RedirectAccountantComponent } from './Routes/redirect-accountant/redirect-accountant.component';
import { RedirectAdminComponent } from './Routes/redirect-admin/redirect-admin.component';
import { GuestGuard } from './Guards/guest.guard';

const routes: Routes = [
  {
    path: 'admin',
    component: RedirectAdminComponent,
  },
  {
    path: 'accountant',
    component: RedirectAccountantComponent,
  },
  // Rotas antigas funcionando no path: '';
  // {
  //   path: 'sign-up',
  //   loadChildren: () =>
  //     import('./Routes/sign-up/sign-up.module').then((m) => m.SignUpModule),
  //   canActivate: [GuestGuard],
  // },
  {
    path: 'partner-sign-up',
    canActivate: [],
    loadChildren: () =>
      import('./Routes/sign-up-partner/sign-up-partner.module').then(
        (m) => m.SignUpPartnerModule
      ),
  },
  {
    path: 'sign-up-affiliate',
    canActivate: [],
    loadChildren: () =>
      import('./Routes/sign-up-affiliate/sign-up-affiliate.module').then(
        (m) => m.SignUpAffiliateModule
      )
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./Routes/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'bfs/:id',
    loadChildren: () => import('./Routes/bank-fetching-setup/bank-fetching-setup.module').then(m => m.BankFetchingSetupPageModule),
    canActivate: [GuestGuard],
  },
  {
    path: 'bfs/:id/:itemId',
    loadChildren: () => import('./Routes/bank-fetching-setup/bank-fetching-setup.module').then(m => m.BankFetchingSetupPageModule),
    canActivate: [GuestGuard],
  },
  {
    path: 'partner-sign-up',
    canActivate: [GuestGuard],
    loadChildren: () =>
      import('./Routes/sign-up-partner/sign-up-partner.module').then(
        (m) => m.SignUpPartnerModule
      ),
  },
  {
    path: 'sign-up-affiliate',
    canActivate: [GuestGuard],
    loadChildren: () =>
      import('./Routes/sign-up-affiliate/sign-up-affiliate.module').then(
        (m) => m.SignUpAffiliateModule
      )
  },
  {
    path: 'sign-up',
    canActivate: [GuestGuard],
    loadChildren: () =>
      import('./Routes/sign-up-summarized/sign-up-summarized.module').then(
        (m) => m.SignUpSummarizedModule
      )
  },
  {
    path: 'company-incorporation',
    canActivate: [],
    loadChildren: () =>
      import('./Routes/company-incorporation/company-incorporation.module').then(
        (m) => m.CompanyIncorporationModule
        )
  },
  {
    path: 'empresanoseua',
    canActivate: [],
    loadChildren: () =>
      import('./Routes/simple-company-incorporation/simple-company-incorporation.module').then(
        (m) => m.SimpleCompanyIncorporationModule
        )
  },
  {
    path: 'pages',
    loadChildren: () => import('./Routes/routes.module').then(m => m.RoutesModule)
  },
  // Novas Rotas do NFC no path 'pages';
  {
    path: '',
    canActivate: [AuthenticatedGuard],
    loadChildren: () => import('./Pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'sales',
    loadComponent: () => import('./Routes/customers/pre-register/pre-register.component').then((comp) => comp.PreRegisterComponent),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always',
    scrollPositionRestoration: 'top',
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
